var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8602 9.13044C21.6636 8.89825 16.9808 3.44505 10.9999 3.44505C5.01902 3.44505 0.33593 8.89825 0.139606 9.13022C-0.0465352 9.3505 -0.0465352 9.64927 0.139606 9.86955C0.33593 10.1017 5.01902 15.5549 10.9999 15.5549C16.9808 15.5549 21.6636 10.1017 21.8602 9.86974C22.0466 9.64949 22.0466 9.3505 21.8602 9.13044ZM10.9999 14.3022C6.59434 14.3022 2.77867 10.6828 1.64914 9.49957C2.7772 8.3153 6.58489 4.69779 10.9999 4.69779C15.4052 4.69779 19.2206 8.31656 20.3506 9.50042C19.2226 10.6847 15.4149 14.3022 10.9999 14.3022Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 5.74176C8.6004 5.74176 6.64819 7.42775 6.64819 9.50002C6.64819 11.5723 8.6004 13.2583 10.9999 13.2583C13.3993 13.2583 15.3515 11.5723 15.3515 9.50002C15.3515 7.42775 13.3993 5.74176 10.9999 5.74176ZM10.9999 12.0055C9.40013 12.0055 8.09878 10.8816 8.09878 9.50002C8.09878 8.11847 9.40018 6.99454 10.9999 6.99454C12.5995 6.99454 13.9009 8.11847 13.9009 9.50002C13.9009 10.8816 12.5996 12.0055 10.9999 12.0055Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOn);
export default __webpack_public_path__ + "static/media/visibility-on.0e2f679396d8b6c5433806f52712cec2.svg";
export { ForwardRef as ReactComponent };